// src/components/desktop/DesktopApp.jsx
import { useState, useEffect } from "react";
import SeoTags from "../../../seo/SeoTags";

import LeftRail from "../left-rail/LeftRail";
import { useLang } from "../../../i18n/LangContext";

import DesktopHero from "./hero/DesktopHero";
import HeroAnimation from "./hero/HeroAnimation";

import DesktopStatsSection from "./stats/DesktopStatsSection";

import DesktopServicesRight from "./services/DesktopServicesRight";
import leftPng from "../../../assets/services/leftPng.png"; // по избор

import DesktopWhyUs from "./whyus/DesktopWhyUs";
import GlobalPNG from "../../../assets/whyus/global.png";
import TransparencyPNG from "../../../assets/whyus/transparency.png";
import TechPNG from "../../../assets/whyus/tech.png";

import DesktopPartners from "./partners/DesktopPartners";
import QmeeLogo from "../../../assets/partners/qmee.png";
import ProdegeLogo from "../../../assets/partners/prodege.png";
import WebToonLogo from "../../../assets/partners/webtoon.png";
import ExmoxLogo from "../../../assets/partners/exmox.png";
import AdGateLogo from "../../../assets/partners/adgate.png";
import TvTwoLogo from "../../../assets/partners/tv-two.png";
import TimewallLogo from "../../../assets/partners/timewall.png";
import AyeTLogo from "../../../assets/partners/ayet.png";

import DesktopFooter from "../footer/DesktopFooter";
import GlobeFx from "../../../assets/footer/globe.png";
import GlobeBase from "../../../assets/footer/globe 1.png";
import LogoPNG from "../../../assets/footer/logo-footer.png";

// import DesktopDifference from "./difference/DesktopDifference";
// import DesktopOffer from "./offer/DesktopOffer";
// import DesktopTestimonials from "./testimonials/DesktopTestimonials";
// import DesktopFooter from "./footer/DesktopFooter";

export default function DesktopAppHome({ onGetStarted = () => {}, onContact = () => {} }) {
  const { lang, t } = useLang();
  const isBG = lang === "bg";

  // 🔹 Overlay loader (над всичко)
  const [showOverlay, setShowOverlay] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Дай време да се заредят шрифтове/стили отдолу
    const t1 = setTimeout(() => setFadeOut(true), 1000);   // започва fade
    const t2 = setTimeout(() => setShowOverlay(false), 1200); // маха overlay-а след анимацията
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  const base = "https://offerwall-web-9dd25471534d.herokuapp.com";
  const url = base;
  const canonical = url;
  const locale = isBG ? "bg_BG" : "en_US";

  const title = isBG
    ? "Givvy Offerwall — Премиум offerwall платформа"
    : "Givvy Offerwall — Premium Offerwall Platform";

  const description = isBG
    ? "Givvy Offerwall свързва глобални рекламодатели и издатели с премиум кампании и надеждни изплащания."
    : "Givvy Offerwall connects advertisers and publishers worldwide with premium campaigns and reliable payouts.";

  const alternates = [{ href: `${base}`, hreflang: "x-default" }];

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Givvy Offerwall",
      "url": base,
      "logo": `${base}/og/logo.png`,
      "sameAs": []
    },
    {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "Givvy Offerwall",
      "applicationCategory": "BusinessApplication",
      "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" },
      "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.8", "ratingCount": "1243" },
      "url": base,
      "image": `${base}/og/og-hero.jpg`,
      "installUrl": [
        "https://play.google.com/store/apps/details?id=com.aura",
        "https://apps.apple.com/app/id000000"
      ]
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Givvy Offerwall",
      "url": base,
      "inLanguage": isBG ? "bg-BG" : "en-US",
      "potentialAction": {
        "@type": "SearchAction",
        "target": `${base}/search?q={query}`,
        "query-input": "required name=query"
      }
    }
  ];

  const sections = [
    { id: "welcome", label: t.nav.home },
    { id: "achievements", label: t.nav.advertise },
    { id: "services", label: t.nav.monetize },
    { id: "whyus", label: t.nav.faq },
    { id: "partners", label: t.nav.about },
    { id: "footer", label: t.nav.about },
    // { id: "testimonials", label: t.nav.testimonials },
  ];

  return (
    <div className="desktop-monetize-area">
      <SeoTags
        title={title}
        description={description}
        url={url}
        canonical={canonical}
        locale={locale}
        alternates={alternates}
        image={`${base}/og/og-hero.jpg`}
        jsonLd={jsonLd}
      />

      {/* Съдържанието се рендва нормално отдолу */}
      
      <LeftRail
        sections={sections}
        railLeft={100}
        navHeight={88}
        dotSize={16}
        dotsSide="left"
        dotsGap={54}
        dotsVAlign="center"
      />
      <DesktopHero
        Right={HeroAnimation}
        onGetStarted={onGetStarted}
        onContact={onContact}
      />
      <DesktopStatsSection />
      <DesktopServicesRight leftSrc={leftPng} />
      <DesktopWhyUs icons={[GlobalPNG, TransparencyPNG, TechPNG]} />
      <DesktopPartners
        logos={[
          QmeeLogo,
          ProdegeLogo,
          WebToonLogo,
          ExmoxLogo,
          AdGateLogo,
          TvTwoLogo,
          TimewallLogo,
          AyeTLogo,
        ]}
      />
      <DesktopFooter
        logoSrc={LogoPNG}
        globeSrc={GlobeBase}
        globeOverlaySrc={GlobeFx}   // <-- тук подаваме overlay-a
        socialLinks={[
          "https://facebook.com/…",
          "https://instagram.com/…",
          "https://youtube.com/…",
          "https://t.me/…",
          "https://x.com/…",
          "https://tiktok.com/@…",
        ]}
      />
      {/* <DesktopHero />
      <DesktopDifference />
      <DesktopOffer />
      <DesktopTestimonials /> */}

      {/* 🔝 Overlay Loader отгоре, fade-out след 2s */}
      {/* {showOverlay && (
        <OverlayLoader duration={2600}
          fadeOut={fadeOut}
          maxWidth={900}
          top="18%" src={auraLogo}>
        </OverlayLoader>
      )} */}
    </div>
  );
}
